import * as React from 'react';
export var FileSize = function (_a) {
    var className = _a.className, size = _a.size;
    var units = ['Byte', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'];
    var magnitude = size <= 1
        ? 1
        : Math.min(Math.ceil(Math.log(size) / Math.log(1024)), units.length);
    var amount = (size / Math.pow(1024, magnitude - 1)).toFixed(magnitude === 1 ? 0 : 1);
    return React.createElement("span", { className: className },
        amount,
        " ",
        units[magnitude - 1]);
};
